import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { GenerarReportesFuncionariosComponent } from './generar-reportes-funcionarios.component';

const routes: Routes = [
  { path: '', component: GenerarReportesFuncionariosComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class GenerarReportesFuncionariosRouting { }
